import { gql } from "@apollo/client"

const GET_PARENT_FIELD = gql`
  query GetListOfFields($idField: ID!) {
    cloneField: field(idField: $idField, type: "system") {
      idField
      field_name
      description
      field_label
      field_description
      field_label_name
      field_type
      field_type_subtype
      field_options {
        label
        value
      }
      field_validation {
        required
        number_min
        number_max
      }
      field_conditional
      allow_custom_config
      rsi_required
    }
  }
`

const GET_CUSTOM_FIELD = gql`
  query GetCustomField($idField: ID!) {
    cloneField: field(idField: $idField, type: "custom") {
      idField
      field_name
      field_name_report
      description
      field_label
      field_description
      field_label_name
      field_type
      field_type_subtype
      field_options {
        label
        value
      }
      field_validation {
        required
        number_min
        number_max
      }
      field_conditional
      rsi_required
    }
  }
`

const ADD_FIELD = gql`
  mutation AddField(
    $organization_id: String!
    $enterprise_id: String!
    $created_by: String!
    $updated_by: String!
    $description: String
    $field_conditional: String
    $field_description: String
    $field_label: String
    $field_name: String
    $field_name_report: String
    $field_position: Int
    $field_type: String
    $field_type_subtype: String
    $field_visibility: Boolean
    $field_parent: String
    $field_validation: String
    $field_options: String
    $fhir_type: String
  ) {
    addField(
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      created_by: $created_by
      updated_by: $updated_by
      description: $description
      field_conditional: $field_conditional
      field_description: $field_description
      field_label: $field_label
      field_name: $field_name
      field_name_report: $field_name_report
      field_position: $field_position
      field_type: $field_type
      field_type_subtype: $field_type_subtype
      field_visibility: $field_visibility
      field_parent: $field_parent
      field_validation: $field_validation
      field_options: $field_options
      fhir_type: $fhir_type
    ) {
      idField
    }
  }
`

const EDIT_FIELD = gql`
  mutation EditField(
    $idField: String!
    $organization_id: String!
    $enterprise_id: String!
    $updated_by: String!
    $description: String
    $field_conditional: String
    $field_description: String
    $field_label: String
    $field_name: String
    $field_name_report: String
    $field_position: Int
    $field_type: String
    $field_type_subtype: String
    $field_visibility: Boolean
    $field_parent: String
    $field_validation: String
    $field_options: String
    $fhir_type: String
  ) {
    editField(
      idField: $idField
      organization_id: $organization_id
      enterprise_id: $enterprise_id
      updated_by: $updated_by
      description: $description
      field_conditional: $field_conditional
      field_description: $field_description
      field_label: $field_label
      field_name: $field_name
      field_name_report: $field_name_report
      field_position: $field_position
      field_type: $field_type
      field_type_subtype: $field_type_subtype
      field_visibility: $field_visibility
      field_parent: $field_parent
      field_validation: $field_validation
      field_options: $field_options
      fhir_type: $fhir_type
    ) {
      idField
    }
  }
`

const DELETE_CUSTOM_FIELD = gql`
  mutation DeleteCustomField($id: String!) {
    deleteCustomField: deleteField(id: $id) {
      idField
    }
  }
`

const GET_FIELDS_LIBRARY = gql`
  query Fields($staff_id: String!, $organization_id: ID, $enterprise_id: ID) {
    systemFields: fields(
      type: "system"
      staff_id: $staff_id
      organization_id: $organization_id
    ) {
      idField
      description
      field_name
      field_label_name
      field_library
      field_label
      field_description
      field_type
      field_name_report
      field_validation {
        required
      }
      rsi_required
      allow_custom_config
      read_only
      system_required
    }
    customFields: fields(
      type: "custom"
      staff_id: $staff_id
      organization_id: $organization_id
      enterprise_id: $enterprise_id
    ) {
      idField
      description
      field_name
      field_label_name
      field_library
      field_name_report
      field_label
      field_description
      field_type
      field_validation {
        required
      }
      field_parent {
        idField
      }
    }
  }
`

export {
  GET_PARENT_FIELD,
  GET_CUSTOM_FIELD,
  EDIT_FIELD,
  DELETE_CUSTOM_FIELD,
  ADD_FIELD,
  GET_FIELDS_LIBRARY,
}
